import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import centralized filter config

const D01BarChartViz08 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by demcat08 (demographic_category_07 in the new JSON)
    const demcat08Counts = filteredData.reduce((acc, item) => {
      const demcat08 = item.demographic_category_08; // Use demographic_category_08 for demcat08
      if (!acc[demcat08]) {
        acc[demcat08] = 0;
      }
      acc[demcat08]++;
      return acc;
    }, {});

    // Sort Demographic Category 08 names alphabetically
    const demcat08Names = Object.keys(demcat08Counts).sort((a, b) =>
      a.localeCompare(b)
    );
    const chartData = demcat08Names.map((demcat08) => demcat08Counts[demcat08]);

    // Update state
    setCategories(demcat08Names);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25; // Set bar height in pixels
    const minBars = 10; // Minimum number of bars to display
    const chartHeight = Math.max(
      barHeight * demcat08Names.length,
      barHeight * minBars
    ); // Total chart height

    // Chart options
    const optionsViz08 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight, // Dynamic height based on number of bars
        width: "95%",
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          distributed: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 28, // Move labels off the bars
        style: {
          colors: ["#000"], // Set data labels to black
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: demcat08Names,
      },
    };

    // Render the chart
    const viz08 = new ApexCharts(
      document.querySelector("#viz-08"),
      optionsViz08
    );
    viz08.render();

    // Clean up the chart on component unmount
    return () => {
      viz08.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", overflowY: "auto" }}>
      <div id="viz-08"></div>
    </div>
  );
};

export default D01BarChartViz08;
